import { useState, useEffect } from "react";
import { Search } from "lucide-react";
import toast from "react-hot-toast";
import { getMasterPrices, deleteMasterPrice } from "@/services/masters";
import PriceMasterTab from "./PriceMasterTab";
import SubscriptionsTab from "./SubscriptionsTab";
import { useScreenPermission } from "@/hooks/useScreenPermission";

export default function PricingManagement() {
  const [activeTab, setActiveTab] = useState<'subscriptions'>('subscriptions');
  const [searchQuery, setSearchQuery] = useState("");
  const [addClickHandler, setAddClickHandler] = useState<(() => void) | null>(null);
  const { canCreate: canCreatePrice,canView:CanViewMasterPrice } = useScreenPermission("masterprices");
  const { canCreate: canCreateSub ,canView:CanViewSubscriptionPlans} = useScreenPermission("plans");
  const canAdd = canCreateSub;

  return (
    <div>
      <div>
        {/* Header */}
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Subscription Plans</h1>
            <p className="text-gray-600">Manage city base prices, KM ranges, and subscription plans</p>
          </div>
          {canAdd && (
          <button
            onClick={() => addClickHandler?.()}
            className="flex items-center gap-2 bg-brand-500 hover:bg-brand-700 text-white font-semibold py-2.5 px-5 rounded-lg transition-all shadow-md hover:shadow-lg"
          >
            {'+ Add Subscription'}
          </button>
          )}
        </div>

        {/* Tabs */}
        {/* <div className="grid grid-cols-1 gap-4 mb-6 items-center justify-center">
         {CanViewSubscriptionPlans && <button
            onClick={() => setActiveTab('subscriptions')}
            className={`flex flex-row items-center justify-center gap-4 px-6 py-4 rounded-lg font-semibold transition-all ${
              activeTab === 'subscriptions'
                ? 'bg-brand-500 text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
            }`}
          >
            📋 Subscriptions
          </button>} */}
        </div>

        {/* Search */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-6">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder={'Search by plan name or city...'}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-400"
            />
          </div>
        </div>

        {/* Content */}
        {/* {activeTab === 'masterprices' && (
          <PriceMasterTab
            searchQuery={searchQuery}
            onAddHandlerReady={setAddClickHandler}
          />
        )} */}
        {activeTab === 'subscriptions' && (
          <SubscriptionsTab
            searchQuery={searchQuery}
            onAddHandlerReady={setAddClickHandler}
          />
        )}
      </div>
  );
}
